'use strict';

customerZone

/**
 * Angular service that wraps around Google's Advanced E-Commerce datalayer.
 *
 * See https://developers.google.com/tag-manager/enhanced-ecommerce
 **/
.service('salesAnalytics', ['$q', 'ProductService', 'Session', 'Storage', function($q, ProductService,
                                                                                          Session, Storage){

    var self = this;

    self.signalCheckout = function(stepIdx, stepName, products, data, type){
        var actionField = {step: stepIdx};
        if (data) actionField.option = data;
        dataLayer.push({
            'event': type || 'checkout',
            'action': stepName,
            'ecommerce': {
                'checkout': {
                    'actionField': actionField,
                    'products': products.map(function(product){
                        return {
                            id: product.id,
                            name: product.name,
                            price: product.price,
                            quantity: 1
                        };
                    })
                }
            }
        });
    };

    self.signalEvent = function(event, data){
        var actionField = {};
        if (data) actionField.option = data;
        dataLayer.push({
            'event': event,
            'action': actionField
        });
    };

    self.signalRouteChange = function(path){
        dataLayer.push({
            event: 'page_view',
            page: {
                'page_name': '/en/e-services' + path,
                'page_authenticated': Session.authenticated()
            },
            user: Session.profile() ? asUser(Session.profile(), Session.subscribers() || []) : null
        });

        function asUser(user, subs) {
            return {
                'user_id': getFunctionalConsent() ? user.id : undefined,
                'user_postpaid_accounts': subs.filter(function(s) { return s.active && s.isPostpaid(); }).length,
                'user_prepaid_accounts': subs.filter(function(s) { return s.active && s.isPrepaid(); }).length
            };
        }

        function getFunctionalConsent() {
            var consentCookie = Storage.getCookie('OptanonConsent');
            if (!consentCookie) return false;
            var filteredCookie = consentCookie.split('&groups=');
            var functionalCookieConsent = filteredCookie[1].split('C0003:');
            return functionalCookieConsent[1][0] === '1';
        }
    };

    self.signalPurchase = function(order, type){
        dataLayer.push({
            'event': type || 'checkout',
            'action': 'purchase',
            ecommerce: {
                purchase: {
                    actionField: {
                        id: order.id,
                        revenue: order.amount
                    },
                    products: (order.products || []).map(function(product){
                        return {
                            id: product.id,
                            name: product.name,
                            price: '' + product.price
                        };
                    })
                }
            }
        });
        return $q.when();
    };


}]);
